<template>
  <div class="staff_member">
    <div class="contents">
      <div class="profile">
        <picture>
          <source :srcset="profileImg"
                    media="(min-width: 768px)">
          <source :srcset="profileImgSp"
                    media="(max-width: 767px)">
            <img :src="profileImg" :alt="profileAlt" />
        </picture>
      </div>

      <section class="faq_contents">
        <StaffFaqLine :image="require('../../assets/img/lab/staff/q1.png')" :imageSp="require('../../assets/img/lab/staff/q1_sp.svg')" alt="q1" question="学生時代に取り組んだことは？" :answer="answer01" />
        <StaffFaqLine :image="require('../../assets/img/lab/staff/q2.png')" :imageSp="require('../../assets/img/lab/staff/q2_sp.svg')" alt="q2" question="クレハに入社した“決め手”は？" :answer="answer02" />
        <StaffFaqLine :image="require('../../assets/img/lab/staff/q3.png')" :imageSp="require('../../assets/img/lab/staff/q3_sp.svg')" alt="q3" question="現在の仕事内容は？" :answer="answer03" />

        <div class="image_cut">
          <picture>
            <source :srcset="imageCut01"
                      media="(min-width: 768px)">
            <source :srcset="imageCut01Sp"
                      media="(max-width: 767px)">
              <img :src="imageCut01" alt="" />
          </picture>
        </div>

        <StaffFaqLine :image="require('../../assets/img/lab/staff/q4.png')" :imageSp="require('../../assets/img/lab/staff/q4_sp.svg')" alt="q4" question="今後、クレハで実現したいこと、挑戦したいことは？" :answer="answer04" />
        <StaffFaqLine :image="require('../../assets/img/lab/staff/q5.png')" :imageSp="require('../../assets/img/lab/staff/q5_sp.svg')" alt="q5" question="ズバリ、クレハのイイところは？" :answer="answer05" />
        <StaffFaqLine :image="require('../../assets/img/lab/staff/q6.png')" :imageSp="require('../../assets/img/lab/staff/q6_sp.svg')" alt="q6" question="休日の過ごし方は？" :answer="answer06" :class="displayNone"/>

        <div class="image_cut">
          <picture>
            <source :srcset="imageCut02"
                      media="(min-width: 768px)">
            <source :srcset="imageCut02Sp"
                      media="(max-width: 767px)">
              <img :src="imageCut02" alt="" />
          </picture>
        </div>

        <div class="schedule" :class="displayNone">
          <picture>
            <source :srcset="schedule"
                      media="(min-width: 768px)">
            <source :srcset="scheduleSp"
                      media="(max-width: 767px)">
            <img :src="schedule" alt="schedule">
          </picture>
        </div>

      </section>
    </div>
    <StaffLink />
  </div>
</template>

<script>
import StaffFaqLine from "@/components/lab/StaffFaqLine.vue";
import StaffLink from "@/components/lab/StaffLink.vue";
export default {
  name: 'staff_contents',
  components: {
    StaffFaqLine,
    StaffLink
  },
  props: {
    profileImg: {
      type: String,
      default: "",
    },
    profileImgSp: {
      type: String,
      default: "",
    },
    profileAlt: {
      type: String,
      default: "",
    },
    answer01: {
      type: String,
      default: "",
    },
    answer02: {
      type: String,
      default: "",
    },
    answer03: {
      type: String,
      default: "",
    },
    answer04: {
      type: String,
      default: "",
    },
    answer05: {
      type: String,
      default: "",
    },
    answer06: {
      type: String,
      default: "",
    },
    imageCut01: {
      type: String,
      default: "",
    },
    imageCut02: {
      type: String,
      default: "",
    },
    imageCut01Sp: {
      type: String,
      default: "",
    },
    imageCut02Sp: {
      type: String,
      default: "",
    },
    schedule: {
      type: String,
      default: "",
    },
    scheduleSp: {
      type: String,
      default: "",
    },
    displayNone: {
      type: String,
      default: "",
    }
  }
}
</script>
<style lang="scss" scoped>
.staff_member {
  background-color: #282828;
  background-image: linear-gradient(#333 1px, transparent 0),
                    linear-gradient(90deg, #333 1px, transparent 0);
  background-size: 10px 10px;
  padding: 100px 0 0 0;
  @media print,screen and (max-width: 900px) {
    padding: 0;
  }
}
.contents {
  max-width: 1000px;
  width: 90%;
  margin: 0 auto;
  padding: 50px 0 100px 0;
  @media print,screen and (max-width: 900px) {
    padding: 50px 0;
  }
}
.faq_contents {
  color: #fff;
}

.image_cut,.schedule {
  margin-top: 100px;
  @media print,screen and (max-width: 767px) {
    margin-top: 50px;
  }
}

.image_cut {
  text-align:center;
  img{
    width:100%;
  }
}

.schedule{
  picture{
    img{
      max-width:107%;
      width:107%;
      margin-left:-3.5%;
      @media print,screen and (max-width: 767px) {
      margin-left:-5%;
      }
    }
  }
}

.display{
  display:none;
}
</style>
